module.exports = __webpack_public_path__ + "img/stu-boy.8ed3624d.png";